import { Component } from '@angular/core';

@Component({
  selector: 'app-self-assessment-landing',
  templateUrl: './self-assessment-landing.component.html',
  styleUrls: ['./self-assessment-landing.component.scss']
})
export class SelfAssessmentLandingComponent {

}
